import { render } from "./TemplateFour.vue?vue&type=template&id=1f1b377f"
import script from "./TemplateFour.vue?vue&type=script&lang=js"
export * from "./TemplateFour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__